import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageSEO from '@/components/feature/PageSEO';
import { articles } from '@/mocks/articles';

const articleContents: Record<string, string> = {
  'french-butter-complete-guide': `
    <p>法国黄油在全球美食界享有盛誉，其浓郁的奶香和细腻的口感让无数烘焙爱好者为之着迷。法国黄油的独特之处在于其传统的<strong>发酵工艺</strong>——在制作过程中加入乳酸菌进行发酵，赋予了黄油独特的坚果香气和微微的酸味。</p>
    
    <h2>为什么法国黄油如此特别？</h2>
    <p>法国黄油的卓越品质源于几个关键因素：首先是<strong>严格的原产地保护制度（AOP）</strong>，确保奶源来自特定地区的优质牧场；其次是传承数百年的传统发酵工艺；最后是法国对黄油乳脂含量的严格标准——通常在82%以上。</p>
    
    <h2>六大法国进口黄油横向评测</h2>
    
    <h3>1. 伊斯尼 Isigny — 发酵黄油的巅峰之作</h3>
    <p>伊斯尼黄油产自法国诺曼底的伊斯尼地区，拥有AOP原产地保护认证。它的奶香极为浓郁，带有明显的坚果和烤面包香气，入口丝滑。在烘焙中表现卓越，是做可颂和法式甜点的首选。<strong>评分：4.9/5.0</strong></p>
    
    <h3>2. 总统 President — 性价比之王</h3>
    <p>总统黄油是法国国民级品牌，在国内超市也极为常见。它的发酵风味相对温和，奶香纯正，非常适合日常家庭烘焙。无论是做蛋糕、饼干还是面包，总统黄油都能提供稳定而出色的表现。<strong>评分：4.7/5.0</strong></p>
    
    <h3>3. 铁塔 Elle & Vire — 专业烘焙之选</h3>
    <p>铁塔黄油同样来自诺曼底，在专业烘焙领域有着极高的口碑。它的特点是奶香和发酵风味平衡得恰到好处，不会过于浓烈，适合做各种法式甜点和奶油酱。<strong>评分：4.6/5.0</strong></p>
    
    <h3>4. 佩森 Paysan Breton — 小众精品</h3>
    <p>佩森黄油在国内相对小众，但在法国本土非常受欢迎。它采用布列塔尼地区的传统工艺，发酵风味更加突出，带有独特的酸奶香气。<strong>评分：4.5/5.0</strong></p>
    
    <h3>5. 蓝风车 Bridel — 入门首选</h3>
    <p>蓝风车黄油价格亲民，口感温和，是非常好的入门级法国发酵黄油。虽然没有伊斯尼那么浓郁的香气，但日常烘焙完全够用。<strong>评分：4.3/5.0</strong></p>
    
    <h3>6. 百吉福 Bel Group — 大众之选</h3>
    <p>百吉福在国内的知名度很高，产品线丰富。它的黄油品质稳定，价格适中，适合大量使用的家庭和烘焙工作室。<strong>评分：4.2/5.0</strong></p>
    
    <h2>选购建议总结</h2>
    <p>如果你是烘焙达人、追求极致口感，<strong>伊斯尼</strong>是你的不二之选；如果追求性价比和稳定品质，<strong>总统</strong>和<strong>铁塔</strong>都非常值得推荐；如果是烘焙新手，从<strong>蓝风车</strong>开始入手也很不错。</p>
  `,
  'fermented-butter-taste-test': `
    <p>发酵黄油近年来在国内烘焙圈越来越火，很多配方都特别标注"请使用发酵黄油"。那么<strong>发酵黄油和普通黄油到底有什么本质区别</strong>？我们实测了5款热门发酵黄油，来一探究竟。</p>
    
    <h2>发酵黄油的制作工艺</h2>
    <p>发酵黄油在制作过程中，会先将鲜奶油进行<strong>乳酸菌发酵</strong>（类似酸奶的制作过程），然后再进行搅拌分离。这个过程会产生多种风味物质，赋予黄油独特的香气层次。</p>
    <p>普通黄油则是直接将鲜奶油搅拌分离，不经过发酵步骤，因此风味更加纯粹、直接。</p>
    
    <h2>五款发酵黄油详细评测</h2>
    
    <h3>香气对比</h3>
    <p>在香气方面，<strong>伊斯尼</strong>表现最为出色，带有明显的榛子坚果香和烤面包气息；<strong>总统</strong>的发酵风味温和但持久；<strong>铁塔</strong>的香气干净利落；<strong>佩森</strong>的酸奶香气独特；<strong>蓝风车</strong>则相对清淡。</p>
    
    <h3>口感对比</h3>
    <p>入口即化的程度：伊斯尼 &gt; 铁塔 &gt; 总统 &gt; 佩森 &gt; 蓝风车。伊斯尼的丝滑程度令人惊艳，几乎是舌头一碰就融化。</p>
    
    <h3>烘焙表现</h3>
    <p>我们用五款黄油分别制作了曲奇饼干。结果显示：伊斯尼做的曲奇香气最浓郁复杂，铁塔做的曲奇酥脆度最好，总统做的曲奇整体均衡稳定。</p>
    
    <h2>发酵黄油值得多花钱吗？</h2>
    <p>如果你经常做<strong>法式甜点、可颂、曲奇</strong>等对香气要求高的烘焙品，发酵黄油绝对值得投资。但如果只是做普通面包或日常烹饪，普通黄油完全够用。</p>
    <p>我们的建议是：<strong>至少准备一块发酵黄油在冰箱里</strong>，做精致烘焙时使用，日常则用普通黄油，这样性价比最高。</p>
  `,
  'home-baking-butter-selection': `
    <p>很多家庭烘焙新手都会问："<strong>家用黄油到底选哪个好？</strong>"答案并不是越贵越好，而是要根据你的具体需求和预算来选。本文从入门到进阶，帮你找到最适合的那一款。</p>
    
    <h2>按烘焙场景选黄油</h2>
    
    <h3>场景一：做饼干和曲奇</h3>
    <p>饼干和曲奇是黄油用量最大的烘焙品类之一。推荐使用<strong>总统</strong>或<strong>安佳</strong>，这两款黄油奶香浓郁、价格适中，性价比极高。如果追求更好的风味层次，可以升级到<strong>伊斯尼</strong>发酵黄油。</p>
    
    <h3>场景二：做蛋糕</h3>
    <p>蛋糕对黄油的细腻度要求较高。推荐<strong>铁塔</strong>或<strong>四叶草</strong>，这两款黄油质地细腻，做出来的蛋糕口感更润更绵密。</p>
    
    <h3>场景三：做面包</h3>
    <p>普通面包对黄油要求不高，<strong>安佳</strong>或<strong>威士兰</strong>完全够用。但如果做布里欧修这类黄油含量高的面包，建议用<strong>总统</strong>级别的发酵黄油。</p>
    
    <h3>场景四：直接涂抹</h3>
    <p>涂抹面包建议用<strong>有盐黄油</strong>或发酵黄油，<strong>伊斯尼有盐款</strong>和<strong>总统有盐款</strong>都非常适合。</p>
    
    <h2>按预算推荐</h2>
    <ul>
      <li><strong>入门级（20-35元）</strong>：安佳、威士兰 — 性价比之选</li>
      <li><strong>进阶级（35-55元）</strong>：总统、铁塔、蓝风车 — 品质稳定</li>
      <li><strong>高端级（55元以上）</strong>：伊斯尼、四叶草 — 极致口感</li>
    </ul>
  `,
  'new-zealand-butter-review': `
    <p>新西兰是全球最大的黄油出口国之一，其<strong>草饲黄油</strong>以纯净、天然著称。新西兰的奶牛全年在牧场上自由放牧，奶源品质非常出色。</p>
    
    <h2>三款主流新西兰黄油对比</h2>
    
    <h3>安佳 Anchor — 市场霸主</h3>
    <p>安佳是国内最知名的新西兰黄油品牌，几乎每个超市都能找到。它的乳脂含量高达82.9%，口感纯正，价格亲民，是<strong>家庭烘焙的性价比之选</strong>。</p>
    
    <h3>威士兰 Westgold — 低调实力派</h3>
    <p>威士兰在国内知名度不如安佳，但品质毫不逊色。它的口感更加纯净清淡，适合不喜欢太重奶味的人。价格也比安佳略低，性价比更高。</p>
    
    <h3>纽麦福 Meadow Fresh — 小众精品</h3>
    <p>纽麦福在国内相对小众，但在新西兰本土市场占有率高。它的风味更加丰富，带有淡淡的青草香气，是草饲黄油的典型代表。</p>
    
    <h2>新西兰黄油 vs 法国黄油</h2>
    <p>新西兰黄油的特点是<strong>纯净、直接、奶味纯正</strong>，没有发酵风味；法国黄油的特点是<strong>复杂、浓郁、层次丰富</strong>。两者没有高下之分，完全取决于你的使用场景和个人偏好。</p>
  `,
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);
  const content = article ? (articleContents[article.slug] || article.excerpt) : '';

  const relatedArticles = article
    ? articles
        .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
        .slice(0, 3)
    : [];

  const articleSchema = article
    ? {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: article.title,
        description: article.excerpt,
        author: { '@type': 'Person', name: article.author },
        datePublished: article.publishDate,
        image: article.image,
        publisher: {
          '@type': 'Organization',
          name: '黄油推荐',
        },
      }
    : undefined;

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900">文章未找到</h1>
            <p className="mt-3 text-foreground-600">你访问的文章不存在或已被移除。</p>
            <Link
              to="/"
              className="mt-6 inline-block px-5 py-2 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <PageSEO
        title={article.title}
        description={article.excerpt}
        keywords={article.tags.join(',')}
        canonicalPath={`/article/${article.slug}`}
        ogType="article"
        schema={articleSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { name: '首页', path: '/' },
            { name: article.category, path: `/category/${article.categorySlug}` },
            { name: article.title },
          ]}
        />

        <article className="w-full px-4 md:px-6 py-8">
          <div className="max-w-3xl mx-auto">
            <div className="mb-6">
              <span className="px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                {article.category}
              </span>
            </div>

            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 leading-snug">
              {article.title}
            </h1>

            <div className="mt-4 flex flex-wrap items-center gap-4 text-sm text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {article.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {article.publishDate}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {article.readTime} 分钟阅读
              </span>
              <span className="flex items-center gap-1 text-primary-500">
                <i className="ri-star-fill"></i>
                {article.rating}
              </span>
            </div>

            <div className="mt-6 w-full h-64 md:h-80 rounded-lg overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                title={`${article.title} - 黄油推荐`}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div
              className="mt-8 prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed article-content"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>

            <div className="mt-8 flex flex-wrap gap-2">
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="w-full px-4 md:px-6 py-10 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <h2 className="font-heading text-lg font-bold text-foreground-900 mb-6">
                相关文章
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.slug}`}
                    className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
                  >
                    <div className="w-full h-40 overflow-hidden">
                      <img
                        src={ra.image}
                        alt={ra.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-4">
                      <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                        {ra.title}
                      </h3>
                      <p className="mt-1 text-xs text-foreground-500">
                        {ra.publishDate} · {ra.readTime} 分钟阅读
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}